import React, { useState, useEffect } from "react";

import { Formik, Form } from "formik";
import * as yup from "yup";

import usersApi from "apis/users";
import { Input, Select, Textarea } from "clearsense-ui/components/formik";

import {
  CREATE_REFERENCE_INITIAL_VALUES,
  CREATE_REFERENCE_VALIDATION_SCHEMA,
} from "../../../constants/createReferenceSource";

const CreateSource = ({ formRef, setCurrentStep, setReferenceSource }) => {
  const [stewards, setStewards] = useState([]);

  const fetchStewards = async () => {
    try {
      const { data } = await usersApi.fetch(1, 1000, "");
      setStewards(
        data?.users?.map(user => ({ label: user.name, value: user.key }))
      );
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    fetchStewards();
  }, []);

  const submitForm = async values => {
    try {
      const payload = {
        name: values?.name,
        description: values?.description,
        reference_source_type: values?.type?.value,
        reference_source_scope: values?.scope?.value,
        drafter_id: values?.drafter?.value,
        approver_id: values?.approver?.value,
      };
      setReferenceSource(payload);
      setCurrentStep(2);
    } catch (error) {
      logger.log(error);
    }
  };

  return (
    <Formik
      initialValues={CREATE_REFERENCE_INITIAL_VALUES}
      validationSchema={yup.object(CREATE_REFERENCE_VALIDATION_SCHEMA)}
      innerRef={formRef}
      onSubmit={submitForm}
    >
      <Form noValidate className="w-full flex flex-col gap-2">
        <Input
          name="name"
          label="Reference Source Name"
          required
          placeholder="Enter Name for the Reference Source"
          data-cy="reference-source-name-input-field"
        />
        <Textarea
          name="description"
          rows={3}
          label="Reference Source Description"
          placeholder="Enter a Description"
          data-cy="reference-source-description-text-area"
        />
        <Select
          name="type"
          strategy="fixed"
          label="Reference Type"
          placeholder="Select Reference Type"
          options={[
            { value: "enterprise", label: "Enterprise" },
            { value: "others", label: "Others" },
          ]}
          required
          data-cy="reference-source-type-selector"
        />
        <Select
          name="scope"
          strategy="fixed"
          label="Scope (Public/Private)"
          placeholder="Select Scope"
          options={[
            { label: "Public", value: "public" },
            { label: "Private", value: "private" },
          ]}
          required
          data-cy="reference-source-scope-selector"
        />
        <Select
          name="drafter"
          label="Drafter"
          strategy="fixed"
          placeholder="Select Steward"
          options={stewards}
          required
          data-cy="reference-source-drafter-selector"
        />
        <Select
          name="approver"
          label="Approver"
          strategy="fixed"
          placeholder="Select Steward"
          options={stewards}
          required
          data-cy="reference-source-approver-selector"
        />
      </Form>
    </Formik>
  );
};

export default CreateSource;
